import { useAtomValue } from "jotai";

import { EmptyState, Icon, PageHeader, Panel } from "@go-novus/ui";

import { readSettingsFailureMessage, settingsAtom } from "#/features/settings";
import * as m from "#/paraglide/messages";

import { SettingsForm, type SettingsTab } from "./settings-form";
import { SettingsSkeleton } from "./settings-skeleton";

export type { SettingsTab } from "./settings-form";

export interface SettingsPageProps {
  onTabChange: (tab: SettingsTab) => void;
  tab: SettingsTab;
}

/** 商家配置的读写；当前标签记在 URL 上，草稿只影响预览。 */
export function SettingsPage({ onTabChange, tab }: SettingsPageProps) {
  const settings = useAtomValue(settingsAtom);

  // 读失败是终局态，摆 EmptyState；还在读就摆骨架屏，版式和表单一致，不跳。
  if (settings.data === undefined) {
    return settings.isError ? (
      <div className="flex flex-col gap-4.5">
        <PageHeader title={m.settings_page_title()} />
        <Panel>
          <EmptyState
            heading={
              readSettingsFailureMessage(settings.error) ??
              m.settings_failure_unexpected()
            }
            icon={<Icon name="info" />}
          />
        </Panel>
      </div>
    ) : (
      <SettingsSkeleton onTabChange={onTabChange} tab={tab} />
    );
  }

  return (
    // 新值不再靠重挂灌进表单：SettingsForm 内部按基线采纳，
    // 拾取写回这类外部改动才不会静默覆盖未保存的草稿。
    <SettingsForm onTabChange={onTabChange} saved={settings.data} tab={tab} />
  );
}
